var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickIcon = function SvgTickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.978 5.236a1.07 1.07 0 0 0-.058-.623 1 1 0 0 0-.394-.47.935.935 0 0 0-1.13.103C20.062 4.508 7.153 18.599 6.82 18.25c-1.11-1.107-1.693-4.076-2.942-4.484-1.832-.524-.361 3.174.472 5.182.832 2.01 2.776 2.912 5.274.99a42.8 42.8 0 0 0 8.328-9.083 41 41 0 0 0 4.025-5.62",
    clipRule: "evenodd"
  })));
};
export default SvgTickIcon;